export default "__VITE_ASSET__FsqNuk4o__"